'use client';
import 'client-only';

import { ToolsTagsFeature } from '../common/features/tools-tags-feature';
import { createUseFlag } from './create-use-flag';

export const useToolsTagsFeature = createUseFlag(ToolsTagsFeature);
